<template>
    <div class="home">
        <div class="banner">
            <Carousel :slides="banners"></Carousel>
        </div>

        <div class="module series">
            <ModuleTitle class="page-title" :caption="whereToBuy.title | pageTitle" :text="whereToBuy.description"></ModuleTitle>
            <ServiceItem v-for="(item, index) in whereToBuy.list" :key="index" :service="item"></ServiceItem>
        </div>
    </div>
</template>

<script>
    import ModuleTitle from '../components/common/ModuleTitle'
    import Carousel from '../components/common/Carousel'
    import ServiceItem from '../components/container/whereToBuy/Service'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'whereToBuy',
        components: {
            Carousel,
            ServiceItem,
            ModuleTitle,
        },
        computed: {
            ...mapState('whereToBuy', {
                banners: ({banners}) => {
                    return banners.map((banner, index) => {
                        return {
                            isPic: banner.type === 'pic',
                            isVideo: banner.type === 'video',
                            video: {
                                ref: 'allSeries' + index,
                                videoSrc: banner.src_file,
                                loop: true,
                                muted: true,
                                autoplay: true,
                            },
                            imgSrc: banner.src_file,
                            width: 1680,
                            height: 600,
                        }
                    })
                },
                whereToBuy: ({whereToBuy}) => {
                    let list = []

                    if (whereToBuy.shop_online) {
                        list.push(
                            {
                                caption: whereToBuy.shop_online.title,
                                desc: whereToBuy.shop_online.description,
                                items: whereToBuy.shop_online.online_shops.map(item => {
                                    return {
                                        imgSrc: item.pic_url,
                                        name: item.title,
                                        desc: item.description,
                                    }
                                }),
                            },
                            {
                                caption: whereToBuy.shop_offline.title,
                                desc: whereToBuy.shop_offline.description,
                                items: whereToBuy.shop_offline.offline_shops.map(item => {
                                    return {
                                        imgSrc: item.pic_url,
                                        name: item.title,
                                        desc: item.description,
                                    }
                                }),
                            }
                        )
                    }

                    return {
                        //title: whereToBuy.where_to_buy && whereToBuy.where_to_buy.title,
                        title: whereToBuy.where_to_buy && whereToBuy.where_to_buy.description,
                        description: whereToBuy.where_to_buy && whereToBuy.where_to_buy.description,
                        list: list
                    }
                },

            })
        },
        methods: {
            ...mapActions('whereToBuy', ['getPageInfo'])
        },
        created() {
            this.getPageInfo(this.$route.path.replace('/',''))
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .series {
        > .title {
            padding-bottom: 0;
        }
    }
</style>
